const investmentFundTypeHistoryFlowLang = {
	type: {
		tag: 'investment.fund_type_history_flow.type',
		fr: 'Type',
		en: 'Type',
	},
	investor: {
		tag: 'investment.fund_type_history_flow.investor',
		fr: 'Canton / Portefeuille',
		en: 'Sub portfolio',
	},
	date: {
		tag: 'investment.fund_type_history_flow.date',
		fr: 'Date',
		en: 'Date',
	},
	amount: {
		tag: 'investment.fund_type_history_flow.amount',
		fr: 'Montant',
		en: 'Amount',
	},
	fund: {
		tag: 'investment.fund_type_history_flow.fund',
		fr: 'Fonds',
		en: 'Fund',
	},
	type_called: {
		tag: 'investment.fund_type_history_flow.type_called',
		fr: 'Appels',
		en: 'Capital calls / Outflows',
	},
	type_distributed: {
		tag: 'investment.fund_type_history_flow.type_distributed',
		fr: 'Distributions',
		en: 'Distributions / Inflows',
	},
	type_engagement: {
		tag: 'investment.fund_type_history_flow.type_engagement',
		fr: 'Engagements',
		en: 'Commitments',
	},
	type_total_value: {
		tag: 'investment.fund_type_history_flow.type_total_value',
		fr: 'Valeur totale',
		en: 'Total Value',
	},
	type_net_called_capital: {
		tag: 'investment.fund_type_history_flow.type_net_called_capital',
		fr: 'Capital net appelé',
		en: 'Capital at work',
	},

	type_accrued_coupon: {
		tag: 'investment.fund_type_history_flow.type_accrued_coupon',
		fr: 'Coupons courrus',
		en: 'Accrued coupons',
	},
};

export default investmentFundTypeHistoryFlowLang;
